import React, { HTMLAttributes } from 'react'

import { Container } from './styles'

interface Props extends HTMLAttributes<HTMLDivElement> {
  isActive?: boolean
}

const InfoBox: React.FC<Props> = ({ isActive, children }) => {
  return <Container isActive={isActive}>{children}</Container>
}

export default InfoBox
